import type {LinkedValueLink} from 'schemaDefinition/types';

export const getSearchString = (linkedValue: LinkedValueLink | undefined) =>
  (linkedValue && linkedValue.linkStatus === 'unverified'
    ? linkedValue.name
    : '') ?? '';
